import React, { type JSX } from "react";
import { t } from "ttag";

import { StoryTile } from "../interfaces";
import { CategoriesFooter } from "./CategoriesFooter";

interface Props {
    data: StoryTile;
    ref?: React.Ref<HTMLAnchorElement>;
}

export const TempurLoveStoryPageTile = (props: Props): JSX.Element => {
    const { data, ref: primaryLinkRef } = props;
    let avatar: JSX.Element | null = null;
    if (data.value.avatar_url) {
        avatar = (
            <>
                <figure className="avatar">
                    <img
                        className="avatar__image"
                        src={data.value.avatar_url}
                        alt={data.value.author}
                    />
                </figure>
                <span>{data.value.author}</span>
            </>
        );
    }

    return (
        <>
            <span className="post__banner">{data.value.tile_banner}</span>
            <div className="post__main-image-container">
                <img
                    className="post__main-image responsive-img"
                    src={data.value.tile_image_url}
                    alt={data.value.tile_title}
                />
            </div>
            <div className="post__avatar-container">{avatar}</div>
            <section className="post-copy">
                <h2 className="post-copy__title">{data.value.tile_title}</h2>
                <div
                    className="post-copy__body"
                    dangerouslySetInnerHTML={{
                        __html: data.value.tile_body,
                    }}
                />
                <a
                    href={data.value.url}
                    ref={primaryLinkRef}
                    className="post-link"
                >
                    {t`Read more`}
                </a>

                <CategoriesFooter
                    categories={data.value.categories}
                    city={data.value.city}
                    state={data.value.state}
                />
            </section>
        </>
    );
};
